import type { ElementType, HTMLAttributes } from 'react';

export type TypographyVariant =
  | 'display'
  | 'heading-lg'
  | 'heading-sm'
  | 'title-lg'
  | 'title-sm'
  | 'body-lg'
  | 'body-sm'
  | 'caption'
  | 'micro';

export type TextProps = HTMLAttributes<HTMLElement> & {
  as?: ElementType;
  variant?: TypographyVariant;
};

export const Text = ({
  as: Component = 'span',
  className,
  variant = 'body-sm',
  ...props
}: TextProps) => (
  <Component
    className={['hotam-text', `hotam-text--${variant}`, className].filter(Boolean).join(' ')}
    {...props}
  />
);
